define('../src/sublayouts/m9-scroller/m9-scroller',['jquery'], function($) {

    'use strict';

    var M9_SCROLL = function($component) {

        this.$component = $component;

        return this;
    };

    /**
     * Initialise component
     */

    M9_SCROLL.prototype.init = function() {
        var _this = this;
        this.currentItem = 0;

        _this.$component.find('.m9-scroller--item').on('mouseover', function() {
            $(this).removeClass('hover')
        });

        this.$component.find('.m9-scroller--right').on('click', function() {
            if (!$(this).hasClass('disabled')) {

                if ($('html').attr('dir') == 'rtl') {
                    _this.currentItem--
                        _this.scrollRtl();
                } else {
                    _this.currentItem++
                        _this.scroll();
                }
            }
        });

        this.$component.find('.m9-scroller--left').on('click', function() {
            if (!$(this).hasClass('disabled')) {
                if ($('html').attr('dir') == 'rtl') {
                    _this.currentItem++
                        _this.scrollRtl();
                } else {
                    _this.currentItem--
                        _this.scroll();
                }
            }
        });

        if ($('html').attr('dir') == 'rtl') {
            _this.checkScrollRtl();
            _this.scrollRtl();
        } else {
            _this.checkScroll();
            _this.scroll();

        }


        this.$component.find('.m9-scroller--main').off('scroll.m9').on('scroll.m9', function() {
            if ($('html').attr('dir') == 'rtl') {
                _this.checkScrollRtl();
            } else {
                _this.checkScroll();
            }
        });
        $(window).off('m9reinit').on('m9reinit', function() {
            _this.init();
        })
    };

    M9_SCROLL.prototype.checkScroll = function() {
        var _this = this,
            firstItemScroll = Math.round(this.$component.find('.m9-scroller--inner').offset().left),
            parentPaddingOffset = Math.round(parseFloat(this.$component.find('.m9-scroller--main').css('padding-left'))),
            rightsp;

        var grnum = Math.abs(firstItemScroll - parentPaddingOffset),
            ss = (grnum + parseFloat(this.$component.find('.m9-scroller--main').width())) - this.$component.find('.m9-scroller--inner').width();
        _this.currentItem = (Math.round(grnum / 382));

        if (grnum < 1) {
            _this.$component.find('.m9-scroller--left').addClass('disabled')
        } else {
            _this.$component.find('.m9-scroller--left').removeClass('disabled')
        }

        if (ss > -50) {
            _this.$component.find('.m9-scroller--right').addClass('disabled')
        } else {
            _this.$component.find('.m9-scroller--right').removeClass('disabled')
        }
    };

    M9_SCROLL.prototype.scroll = function() {
        var _this = this,
            scroll;

        this.$component.find('.m9-scroller--main').animate({
            scrollLeft: 382 * _this.currentItem
        }, 250);
    };


    M9_SCROLL.prototype.checkScrollRtl = function() {
        var _this = this,
            firstItemScroll = Math.round(this.$component.find('.m9-scroller--inner').offset().left),
            parentPaddingOffset = Math.round(parseFloat(this.$component.find('.m9-scroller--main').css('padding-right'))),
            rightsp;

        var ss = parseFloat(this.$component.find('.m9-scroller--inner').width()) - (parseFloat(this.$component.find('.m9-scroller--main').outerWidth()) + Math.abs(firstItemScroll) - parentPaddingOffset),
            grnum = firstItemScroll;
        _this.currentItem = (Math.round(ss / 382));


        if (grnum < -50) {
            _this.$component.find('.m9-scroller--left').removeClass('disabled')
        } else {
            _this.$component.find('.m9-scroller--left').addClass('disabled')
        }
        if (_this.currentItem == 0) {
            _this.$component.find('.m9-scroller--right').addClass('disabled')
        } else {
            _this.$component.find('.m9-scroller--right').removeClass('disabled')
        }
    };

    M9_SCROLL.prototype.scrollRtl = function() {
        var _this = this,
            thiScroll = this.$component.find('.m9-scroller--inner').offset().left,
            scroll;

        if (_this.currentItem == 0) {
            scroll = 0;
        } else {
            scroll = -(382 * _this.currentItem);
        }

        /*if($('html').attr('dir') == 'rtl' ){
             scroll= -(382*_this.currentItem);
         }else{
             scroll= (382*_this.currentItem);
         }*/


        this.$component.find('.m9-scroller--main').animate({
            scrollLeft: scroll
        }, 250);
    };

    return M9_SCROLL;
});

